export interface ServiceCategoryOption {
  id: string;
  label: string;
}

/** Stable comparison key for a tenant-owned service category. */
export function serviceCategoryId(value: unknown): string {
  const label = String(value ?? "").trim().toLocaleLowerCase().replace(/\s+/g, " ");
  return label ? "category:" + label : "";
}

/** Filter key, retaining the reserved unfiltered `all` value. */
export function serviceFilterId(value: unknown): string {
  const text = String(value ?? "").trim();
  return text === "all" ? "all" : text.indexOf("category:") === 0 ? text : serviceCategoryId(text);
}

/** Build the picker from the categories the tenant actually returned. */
export function serviceCategoryOptions(services: Array<{ cat?: unknown }> | null | undefined): ServiceCategoryOption[] {
  const options: ServiceCategoryOption[] = [{ id: "all", label: "All" }];
  const seen = new Set<string>();
  for (const service of services || []) {
    const label = String(service?.cat ?? "").trim();
    const id = serviceCategoryId(label);
    if (!id || seen.has(id)) continue;
    seen.add(id);
    options.push({ id, label });
  }
  return options;
}

/** Missing categories are intentionally visible only under the All filter. */
export function serviceMatchesCategory(service: { cat?: unknown }, selected: unknown): boolean {
  const id = serviceFilterId(selected);
  return id === "all" || (!!serviceCategoryId(service?.cat) && serviceCategoryId(service?.cat) === id);
}
